export default __webpack_public_path__ + "static/media/Chat_alt_add_light2.891f8fd8.svg";